import { FC } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { ModalRow } from "components/Rows";
import { Accordion } from "components";
import { toLocaleStringWithCurrency } from "helpers/funcs";
import { InfoRows } from "../styled";
import { CurrenciesStore } from "stores";
import type { FntClaimInfo } from "api/types/fntClaim";

interface WithdrawInfoRowsProps {
  claimInfo: FntClaimInfo | null;
}

const WithdrawInfoRows: FC<WithdrawInfoRowsProps> = ({ claimInfo }) => {
  const { t } = useTranslation();
  const { currencies } = CurrenciesStore;

  return (
    <Accordion
      label={t("TOTAL")}
      subLabel={toLocaleStringWithCurrency(
        claimInfo && Number(claimInfo.amount) > 0
          ? Number(claimInfo.amount)
          : 0,
        claimInfo?.currencyName || "USDT",
        currencies
      )}
    >
      <InfoRows>
        {claimInfo && (
          <ModalRow
            keyText={t("FIXED_FEE")}
            value={toLocaleStringWithCurrency(
              claimInfo.feeAmount,
              claimInfo.feeCurrencyName || "USDT",
              currencies
            )}
          />
        )}
      </InfoRows>
    </Accordion>
  );
};

export default observer(WithdrawInfoRows);
